import React from 'react';
import { Box, Container, Typography } from '@mui/material';

import { Button, Link } from 'gatsby-theme-material-ui';
import SvgImsKit from './SvgImsKit';

export default function BlackFridayBanner({
  banner,
  isMobile,
  setIsModalOpen,
  handleClick,
}) {
  let buttonHandle = null;
  if (banner.buttonAction === 'modal') {
    buttonHandle = () => setIsModalOpen && setIsModalOpen(true);
  }
  if (banner.buttonAction === 'link') {
    buttonHandle = handleClick;
  }
  const button = (
    <Button
      size={isMobile ? 'smallest' : 'medium'}
      variant="kitPrimary"
      onClick={buttonHandle}
      sx={{
        position: 'relative',
        transform: 'skew(-10deg)',
        color: 'white',
        backgroundColor: 'transparent',
        borderImage:
          'linear-gradient(to bottom right, #8B57C1 -0.01%, #0FF 31.97%, #F0F 75.24%, #FFF 99.77%) 1',
        borderWidth: { xs: '3px', xl: '4px' },
        borderStyle: 'solid',
        paddingInline: { xs: 0.5, md: 1, lg: 1.5, xl: 2 },
        paddingBlock: { xs: 0.5, md: 1, lg: 1, xl: 1 },
        ':hover': {
          backgroundColor: 'transparent',
          boxShadow: '0px 4px 20px rgba(255, 188, 191, 0.7)',
        },
        ':active': {
          borderRadius: 0,
          backgroundColor: 'transparent',
          boxShadow: '0px 2px 10px rgba(255, 188, 251, 0.5)',
        },
      }}
    >
      <Typography
        variant="desktopH5"
        sx={{
          transform: 'skew(10deg)',
          fontWeight: 700,
          fontSize: { xs: 12, md: 14, lg: 22, xl: 26 },
        }}
      >
        {banner.buttonText?.split(' ').join(' ')}
      </Typography>
    </Button>
  );
  return (
    <Box
      sx={{
        height: { xs: 40, sm: 48, md: 80, lg: 90 },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            background:
              'radial-gradient(101.22% 53.04% at 50% 49.95%, #666 1.16%, #333 23.59%, #000 72.81%);',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <SvgImsKit isMobile={isMobile} />
        </Box>
      </Box>
      <Container
        maxWidth={'xl'}
        sx={{
          position: 'relative',
          height: '100%',
          display: 'flex',
          px: { xs: 'calc(48vw - 165px)', sm: 8, md: 12, lg: 10 },
          gap: { xs: 'calc(30vw - 100px)', sm: 1, md: 4, lg: 16, xl: 2 },
          alignItems: 'center',
          justifyContent: { xs: 'flex-start' },
        }}
      >
        <Box
          sx={{
            minWidth: 157,
            // maxWidth: { xs: 100, xl: 300 },
            ml: { xs: 0, md: 5, xl: 10 },
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'flex-start', lg: 'center' },
          }}
        >
          <Typography
            variant="desktopH4"
            sx={{
              color: 'kit.text.mainInverse',
              fontSize: {
                xs: 'calc(10px + (4 * (100vw - 360px) / 175))',
                sm: 14,
                md: 18,
                lg: 28,
              },
              fontWeight: 400,
              minWidth: { xs: 10, md: 161 },
              // maxWidth: { xs: 188, sm: 230, md: 456, lg: 686 },
              letterSpacing: { xs: -0.2, md: 2.25 },
            }}
          >
            {(isMobile ? banner.bannerMobileText : banner.bannerDesktopText)
              ?.split('\\n')[0]
              ?.split(' ')
              .map((str) => {
                const isPercentage = /^\d+%$/.test(str);
                return (
                  <Typography
                    component={'span'}
                    key={str}
                    sx={{
                      color: isPercentage ? 'kit.text.accent' : 'inherit',
                    }}
                  >
                    {str}{' '}
                  </Typography>
                );
              })}
          </Typography>

          <Typography
            noWrap
            variant="desktopH4"
            sx={{
              color: 'kit.text.mainInverse',
              fontSize: {
                xs: 'calc(8px + (4 * (100vw - 360px) / 175))',
                sm: 14,
                md: 18,
                lg: 36,
              },
              fontWeight: 400,
              minWidth: { xs: 10, md: 161 },
              // maxWidth: { xs: 188, sm: 230, md: 456, lg: 686 },
              letterSpacing: { xs: -0.2, md: 2.25 },
            }}
          >
            {(isMobile ? banner.bannerMobileText : banner.bannerDesktopText)
              ?.split('\\n')[1]
              ?.split(' ')
              .map((str) => {
                const isPercentage = /^\d+%$/.test(str);
                return (
                  <Typography
                    component={'span'}
                    key={str}
                    sx={{
                      color: isPercentage ? 'kit.text.accent' : 'inherit',
                    }}
                  >
                    {str}{' '}
                  </Typography>
                );
              })}
          </Typography>
        </Box>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            right: '25%',
            transform: {
              xs: 'translate(calc(18vw), -50%)',
              lg: 'translate(calc(23vw - 35%), -50%)',
            },
          }}
        >
          {banner.buttonAction === 'link' && (
            <Link
              href={banner.buttonLink}
              target="_blank"
              underline="none"
              children={button}
            />
          )}
          {banner.buttonAction === 'modal' && button}
        </Box>
      </Container>
    </Box>
  );
}
